export default __webpack_public_path__ + "static/here_we_go-fa919e9604f6211c0bf8156df34d5b4a.png";